import * as sterlingparker from './UpcomingMatches.styles.sterlingparker';
import * as betprofessor from './UpcomingMatches.styles.betprofessor';
import * as volcanobet from './UpcomingMatches.styles.volcanobet';
import * as puntgenie from './UpcomingMatches.styles.puntgenie';
import * as junglebet from './UpcomingMatches.styles.junglebet';
import * as fiestabet from './UpcomingMatches.styles.fiestabet';
import * as puntcity from './UpcomingMatches.styles.puntcity';
import * as betgalaxy from './UpcomingMatches.styles.betgalaxy';
import * as betroyale from './UpcomingMatches.styles.betroyale';
import * as juicybet from './UpcomingMatches.styles.juicybet';
import * as goldenrush from './UpcomingMatches.styles.goldenrush';
import * as vikingbet from './UpcomingMatches.styles.vikingbet';
import * as questbet from './UpcomingMatches.styles.questbet';
import * as wellbet from './UpcomingMatches.styles.wellbet';
import * as sugarcastle from './UpcomingMatches.styles.sugarcastle';
import * as buffalobet from './UpcomingMatches.styles.buffalobet';
import * as oldgill from './UpcomingMatches.styles.oldgill';
import * as titanbet from './UpcomingMatches.styles.titanbet';
import * as gigabet from './UpcomingMatches.styles.gigabet';
import * as slambet from './UpcomingMatches.styles.slambet';
import * as betstride from './UpcomingMatches.styles.betstride';
import * as templebet from './UpcomingMatches.styles.templebet';
import * as goldenbet888 from './UpcomingMatches.styles.goldenbet888';
import * as hyperbet from './UpcomingMatches.styles.hyperbet';
import * as bet777 from './UpcomingMatches.styles.bet777';
import * as chromabet from './UpcomingMatches.styles.chromabet';
import * as bet575 from './UpcomingMatches.styles.bet575';
import * as betblast from './UpcomingMatches.styles.betblast';
import * as pyramidbet from './UpcomingMatches.styles.pyramidbet';
import * as magnumbet from './UpcomingMatches.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  betprofessor,
  volcanobet,
  puntgenie,
  junglebet,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
